import "./ButtonVariable.css";
import { useChatboxDispatchContext, useChatboxStateContext } from "../../../context/ChatboxContext";
import variables from '../../../assets/variables.svg';

const ButtonVariable = () => {

    const { valueToggleVariablesList } = useChatboxStateContext();

    const dispatch = useChatboxDispatchContext();

    const toggleVariables = () => dispatch({ type: "toggleVariablesList" });

    return (
        <button id="kwalys-variable" onClick={toggleVariables} className={valueToggleVariablesList ? 'active' : ''}>
            <img src={variables} alt="variable" width="18px"/>
        </button>
    );
};

export default ButtonVariable;